/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AutocompleteTerm_jsonld = {
    readonly '@id'?: string;
    readonly '@type'?: string;
    type?: AutocompleteTerm_jsonld.type;
    id?: string;
    name?: string;
    caption?: string;
};
export namespace AutocompleteTerm_jsonld {
    export enum type {
        COUNTRY = 'country',
        VOIVODESHIP = 'voivodeship',
        REGION = 'region',
        CITY = 'city',
        ACCOMMODATION = 'accommodation',
        POI = 'poi',
    }
}
